export default __webpack_public_path__ + "static/media/header-2x.acf0c053.png";